import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OffCanvasItem } from '../../components/offCanvasNavigation';
import { getAutomationInfo } from '../../services/communityAutomation';
import { getHelpStaffInfo } from '../../services/help';
import { STAFF_PATH } from './tabs';

/**
 * Item "Keenvil Staff" (violeta): aparece si community-api o townhall-api dicen que la cuenta es staff.
 * Rechequea al cambiar la sesion.
 */
export class StaffNavItem extends Component {
  state = { staff: false };

  componentDidMount() {
    this.mounted = true;
    this.check();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.check();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  check() {
    const { token } = this.props;
    Promise.all([getAutomationInfo(token), getHelpStaffInfo(token)]).then(
      ([communities, help]) => {
        if (this.mounted) {
          this.setState({
            staff: !!(
              (communities && communities.staff) ||
              (help && help.staff)
            )
          });
        }
      }
    );
  }

  render() {
    if (!this.state.staff) {
      return null;
    }
    const { currentPath } = this.props;
    return (
      <OffCanvasItem
        label="Keenvil Staff"
        icon="staff"
        linkTo={STAFF_PATH}
        staff
        isActive={currentPath.startsWith(STAFF_PATH)}
      />
    );
  }
}

const mapStateToProps = state => ({
  token: state.session.user && state.session.user.token
});

export default connect(mapStateToProps)(StaffNavItem);
